
import { FiltroModel } from "./FiltroModel";

export class ValidacaoDadosModel {
    reportFilters: FiltroModel[];
    queryText: string;
    pageSize: number;
    connectionId: number;
}


// WEBPACK FOOTER //
// C:/Users/ewerton.w.da.silva/Documents/Visual Studio 2017/Projects/SCL_Valia/SCL_Valia/src/app/shared/classes/ValidacaoDadosModel.ts